import { StoreMinusIcon } from './StoreMinusIcon';

/**
 * author: Dylan Oli
 * id D52803B6-8580-4C06-AA9F-96B4748286DB
 * name store-minus
 * version: 5.7.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/store-minus.svg
 * tags
 * - Places 
 * - Shopping 
 */
export const ShopMinusIcon = StoreMinusIcon;
export default ShopMinusIcon